import { MATCHED_DOCUMENT_FIELD_LOCK_TOOLTIP } from "@common/helpers/matched-document-transaction-fields";
import { buildLockedSuffix } from "./lockedSuffix";

export const MATCHED_TO_INVOICE_OR_BILL_LOCK_TOOLTIP =
    MATCHED_DOCUMENT_FIELD_LOCK_TOOLTIP;

/**
 * Suffix appended to a bulk action's heading (e.g. "Set class for 3
 * transactions") when some of the selected transactions are matched to an
 * invoice or bill and therefore excluded from the update — see
 * partitionSelectionByInvoiceOrBillLock. Returns an empty string when
 * nothing is locked, so callers can append it unconditionally.
 */
export function buildInvoiceOrBillLockedSuffix(lockedCount: number): string {
    return buildLockedSuffix({
        lockedCount,
        reason: "matched to an invoice or bill",
    });
}
